import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function PhotoLightbox({ photos, index, onClose, onIndexChange }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft" && index > 0) onIndexChange(index - 1);
      else if (e.key === "ArrowRight" && index < photos.length - 1) onIndexChange(index + 1);
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [index, photos.length, onClose, onIndexChange]);

  if (index < 0 || index >= photos.length) return null;

  return (
    <div
      className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center backdrop-blur-sm"
      onClick={onClose}
      data-testid="photo-lightbox"
    >
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-4 right-4 stb-icon-btn"
        aria-label="Zavřít"
        data-testid="lightbox-close"
      >
        <X size={22} />
      </button>

      {index > 0 && (
        <button
          onClick={(e) => { e.stopPropagation(); onIndexChange(index - 1); }}
          className="absolute left-4 top-1/2 -translate-y-1/2 stb-icon-btn"
          aria-label="Předchozí"
          data-testid="lightbox-prev"
        >
          <ChevronLeft size={28} />
        </button>
      )}
      {index < photos.length - 1 && (
        <button
          onClick={(e) => { e.stopPropagation(); onIndexChange(index + 1); }}
          className="absolute right-4 top-1/2 -translate-y-1/2 stb-icon-btn"
          aria-label="Další"
          data-testid="lightbox-next"
        >
          <ChevronRight size={28} />
        </button>
      )}

      <img
        src={photos[index]}
        alt=""
        className="max-w-[95vw] max-h-[90vh] object-contain select-none"
        onClick={(e) => e.stopPropagation()}
        data-testid="lightbox-image"
      />
      <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/70 stb-mono text-xs">
        {index + 1} / {photos.length}
      </p>
    </div>
  );
}
